import { defineAsyncComponent } from 'vue'
import { tabOutlineLink } from 'quasar-extras-svg-icons/tabler-icons-v3'

import type { FeatureConfig } from 'src/models'

import { hasInvalidDigitalTwins } from 'src/utils/type-checks'

const featureConfig: FeatureConfig = {
  drawer: {
    drawerComponent: defineAsyncComponent(() => import('./RelationsFeatureDrawerMain.vue')),
    icon: tabOutlineLink,
    label: 'Relationships',
    hide: hasInvalidDigitalTwins
  },
  contextMenuItems: {
    component: defineAsyncComponent(() => import('./RelationsFeatureContextMenuItems.vue'))
  }
}

export default featureConfig
